const COMMON_COLORS = {
  black: { name: "Black", value: "#111827" },
  white: { name: "White", value: "#F8FAFC" },
  blue: { name: "Blue", value: "#2563EB" },
  navy: { name: "Navy", value: "#1E3A8A" },
  grey: { name: "Grey", value: "#6B7280" },
  red: { name: "Red", value: "#DC2626" },
  green: { name: "Green", value: "#16A34A" },
  pink: { name: "Pink", value: "#EC4899" },
  purple: { name: "Purple", value: "#9333EA" },
  brown: { name: "Brown", value: "#78350F" },
  tan: { name: "Tan", value: "#B45309" },
  orange: { name: "Orange", value: "#EA580C" },
  cream: { name: "Cream", value: "#FEF3C7" },
  silver: { name: "Silver", value: "#9CA3AF" },
  yellow: { name: "Yellow", value: "#FACC15" },
};

export const PRODUCTS = [
  {
    id: 1,
    title: "Levi's Slim Fit Denim Jeans",
    category: "mens",
    price: 2499,
    rating: 4.9,
    reviews: 184,
    image: "https://images.unsplash.com/photo-1542272604-787c3835535d?w=800",
    brand: "Levi's",
    badge: "Best Seller",
    available: true,
    description:
      "Premium slim-fit denim jeans crafted for comfort and everyday style.",
    sizes: ["30", "32", "34", "36"],
    colors: [COMMON_COLORS.blue, COMMON_COLORS.black, COMMON_COLORS.grey],
  },

  {
    id: 2,
    title: "Allen Solly Casual Shirt",
    category: "mens",
    price: 1799,
    rating: 4.8,
    reviews: 92,
    image: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=800",
    brand: "Allen Solly",
    badge: "New Arrival",
    available: true,
    description: "Modern casual shirt perfect for office and weekend wear.",
    sizes: ["S", "M", "L", "XL"],
    colors: [COMMON_COLORS.white, COMMON_COLORS.navy, COMMON_COLORS.blue],
  },

  {
    id: 3,
    title: "Women's Floral Summer Dress",
    category: "womens",
    price: 2199,
    rating: 4.9,
    reviews: 156,
    image: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=800",
    brand: "Only",
    badge: "Trending",
    available: true,
    description: "Elegant floral dress designed for comfort and style.",
    sizes: ["S", "M", "L"],
    colors: [COMMON_COLORS.pink, COMMON_COLORS.red, COMMON_COLORS.purple],
  },

  {
    id: 4,
    title: "Louis Philippe Formal Blazer",
    category: "mens",
    price: 4999,
    rating: 5.0,
    reviews: 67,
    image: "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=800",
    brand: "Louis Philippe",
    badge: "Premium",
    available: true,
    description:
      "Sophisticated formal blazer for business and special occasions.",
    sizes: ["38", "40", "42", "44"],
    colors: [COMMON_COLORS.black, COMMON_COLORS.navy, COMMON_COLORS.grey],
  },

  {
    id: 5,
    title: "Women's Handbag",
    category: "accessories",
    price: 1899,
    rating: 4.7,
    reviews: 84,
    image: "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=800",
    brand: "Lavie",
    badge: null,
    available: true,
    description:
      "Premium handbag with spacious compartments and elegant design.",
    sizes: ["One Size"],

    colors: [COMMON_COLORS.tan, COMMON_COLORS.black, COMMON_COLORS.brown],
  },

  {
    id: 6,
    title: "U.S. Polo Men's Polo T-Shirt",
    category: "mens",
    price: 1499,
    rating: 4.8,
    reviews: 201,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800",
    brand: "U.S. Polo",
    badge: "Best Seller",
    available: true,
    description: "Classic polo t-shirt crafted from premium cotton.",
    sizes: ["S", "M", "L", "XL"],
    colors: [COMMON_COLORS.white, COMMON_COLORS.green, COMMON_COLORS.navy],
  },

  {
    id: 7,
    title: "Kids Printed T-Shirt",
    category: "kids",
    price: 799,
    rating: 4.6,
    reviews: 48,
    image: "https://images.unsplash.com/photo-1519238359922-989348752efb?w=800",
    brand: "Hopscotch",
    badge: null,
    available: true,
    description: "Soft cotton t-shirt designed for all-day comfort.",
    sizes: ["2Y", "4Y", "6Y", "8Y"],

    colors: [COMMON_COLORS.yellow, COMMON_COLORS.blue, COMMON_COLORS.red],
  },

  {
    id: 8,
    title: "Nike Running Shoes",
    category: "footwear",
    price: 3999,
    rating: 4.9,
    reviews: 312,
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800",
    brand: "Nike",
    badge: "Trending",
    available: true,
    description: "Lightweight running shoes built for performance and comfort.",
    sizes: ["7", "8", "9", "10"],
    colors: [COMMON_COLORS.black, COMMON_COLORS.white, COMMON_COLORS.orange],
  },

  {
    id: 9,
    title: "Raymond Ethnic Kurta",
    category: "ethnic",
    price: 2799,
    rating: 4.8,
    reviews: 76,
    image: "https://images.unsplash.com/photo-1617137968427-85924c800a22?w=800",
    brand: "Raymond",
    badge: "Festive",
    available: true,
    description: "Premium ethnic kurta perfect for celebrations and festivals.",
    sizes: ["S", "M", "L", "XL"],
    colors: [COMMON_COLORS.cream, COMMON_COLORS.brown, COMMON_COLORS.green],
  },

  {
    id: 10,
    title: "Fastrack Smart Watch",
    category: "watches",
    price: 3499,
    rating: 4.7,
    reviews: 129,
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800",
    brand: "Fastrack",
    badge: "Popular",
    available: true,
    description: "Smart watch with fitness tracking and stylish design.",
    sizes: ["One Size"],
    colors: [COMMON_COLORS.black, COMMON_COLORS.silver, COMMON_COLORS.blue],
  },

  {
    id: 11,
    title: "Women's Sunglasses",
    category: "sunglasses",
    price: 1299,
    rating: 4.6,
    reviews: 58,
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=800",
    brand: "Fossil",
    badge: null,
    available: true,
    description: "Stylish sunglasses with UV protection.",
    sizes: ["One Size"],
    colors: [COMMON_COLORS.black, COMMON_COLORS.brown],
  },

  {
    id: 12,
    title: "Premium Leather Wallet",
    category: "accessories",
    price: 999,
    rating: 4.8,
    reviews: 94,
    image: "https://images.unsplash.com/photo-1627123424574-724758594e93?w=800",
    brand: "WildHorn",
    badge: "Popular",
    available: true,
    description: "Genuine leather wallet with premium finish.",
    sizes: ["One Size"],
    colors: [COMMON_COLORS.brown, COMMON_COLORS.black, COMMON_COLORS.tan],
  },
];
